export default __webpack_public_path__ + "static/home_page_estimates-0615e4c8f07452cbeec9e0be2decb906.webm";